import { Context, Effect, Layer } from 'effect';
import api from '@/domain/api';

// Service constructor that simply returns existing api object
export const makeApiService = Effect.sync(() => api);

export class ApiService extends Context.Tag('ApiService')<ApiService, Effect.Effect.Success<typeof makeApiService>>() {
  // ApiServiceLayer but presented as static Service field not to import
  // it separately where its required but invoke as ApiService.make
  static make = Layer.effect(this, makeApiService);
}

export const ApiServiceLayer = Layer.effect(ApiService, makeApiService);
